import { portalApi } from "./client";

// TPS Servicing Portal PR-D — portal-side client + DTO type for the firm's
// "Debt-Collector Language" surface. Mirrors the C# record the backend
// exposes under /api/portal/tps/debt-collector-languages. Kept inside the
// portal bundle so nothing here imports staff types.
//
// The editor-time "THIS IS AN EXAMPLE. REVIEW WITH COUNSEL BEFORE APPROVING."
// banner is a UI-only constant rendered above the body in the tab — it is
// never part of `bodyText` and is never sent to the server.

export type TpsDebtCollectorLanguageStatus = "Draft" | "Approved";

export interface TpsDebtCollectorLanguage {
  stateCode: string;
  version: number;
  status: TpsDebtCollectorLanguageStatus;
  bodyText: string;
  approvedAt: string | null;
  isApproved: boolean;
}

export const tpsDebtCollectorLanguageApi = {
  list: () =>
    portalApi.get<TpsDebtCollectorLanguage[]>("/tps/debt-collector-languages"),
  // GET lazily creates a Version 1 Draft (seeded with the primed default) when
  // the firm hasn't authored this state yet.
  get: (stateCode: string) =>
    portalApi.get<TpsDebtCollectorLanguage>(
      `/tps/debt-collector-languages/${stateCode}`,
    ),
  update: (stateCode: string, bodyText: string) =>
    portalApi.put<TpsDebtCollectorLanguage>(
      `/tps/debt-collector-languages/${stateCode}`,
      { bodyText },
    ),
  approve: (stateCode: string) =>
    portalApi.post<TpsDebtCollectorLanguage>(
      `/tps/debt-collector-languages/${stateCode}/approve`,
    ),
};
